module.exports = __webpack_public_path__ + "img/waistband_buttons_quantity.dc73089a.png";